/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import styles from "./index.module.scss"
import { verifyMode } from "../../service/sign"
import { aliyuncaptcha } from "../../service/sign"


interface Props {
  reset?: boolean;
  style?: any
  style2?: any
}
const Verify: React.FC<Props> = ({ reset, style, style2 }) => {
  const [type, setType] = useState(null)
  let captcha

  const getInstance = (instance) => {
    captcha = instance
  }

  const captchaVerifyCallback = async (captchaVerifyParam) => {
    // 1.向后端发起业务请求，获取验证码验证结果和业务结果
    const { data } = await aliyuncaptcha({
      captcha: captchaVerifyParam,
    })
    if(data.result){
      window['captcha'] = JSON.stringify(data)
    }
    return {
      captchaResult: data.result, // 验证码验证是否通过，boolean类型，必选
      bizResult: data.result, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
    }

  }
  // 验证通过后调用
  const onBizResultCallback = ()  => {
    console.log('onBizResultCallback')
    captcha.hide()
  }


  const initYpRiddler = () => {
    new window['YpRiddler']({
      appId: '98a0a57888d74e71acc4e699de93f962',
      expired: 10,
      mode: 'flat',
      winWidth: window.innerWidth > 500 ? 420 : '75%',
      lang: 'zh-cn',
      container: document.getElementById('cbox'),
      version: 'v1',
      onSuccess: function (validInfo, close, useDefaultSuccess) {
        useDefaultSuccess.call(null, true)
        window['captcha'] = JSON.stringify({
          token: validInfo.token,
          authenticate: validInfo.authenticate
        })
        close()
      },
      onFail: function (code, msg, retry) {
        console.log('出错啦：' + msg + ' code: ' + code)
        window['captcha'] = ''
        retry()

      },
      beforeStart: function (next) {
        // console.log('验证马上开始')
        window['captcha'] = ''
        next()
      },
      onExit: function () {
        // console.log('退出验证')
      },
    })
  }
  const initAliyun = (rem) => {
    (window as any).initAliyunCaptcha({
      SceneId: '14nkvqxq', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      prefix: '13kf7n', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
      mode: 'embed', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
      element: '#cbox', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      button: '#AliyunCaptcha', // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
      captchaVerifyCallback: captchaVerifyCallback, // 业务请求(带验证码校验)回调函数，无需修改
      onBizResultCallback: onBizResultCallback, // 业务请求结果回调函数，无需修改
      getInstance: getInstance, // 绑定验证码实例函数，无需修改
      immediate:true,
      rem: rem,
      region:'sgp',
      slideStyle: {
        width: 360,
        height: 40,
      }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
      language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
    })
  }

  useEffect(() => {
    if (reset) return
    if(type === 'yunpian'){
      initYpRiddler()
    }else if(type === 'aliyun-image-restore'){
      const pageWidth = window.innerWidth
      let rem = 1
      if (pageWidth < 380) {
        rem = pageWidth < 340 ? 0.74 : 0.86
      }
      initAliyun(rem)
    }
    return () => {
      // console.log('此处销毁人机验证')
      document.getElementById('aliyunCaptcha-mask')?.remove()
      document.getElementById('aliyunCaptcha-window-popup')?.remove()
    }

  },[type,reset])

  const getCaptcha_type = async () => {
    const res = await verifyMode()
    setType(res)
  }


  useEffect(() => {
    getCaptcha_type()
  }, [])


  return (
    <div className={type !== 'aliyun-nvc' ? styles.yunPianVerify : styles.aLiVerify} style={{ ...style }}>
      {
        reset ? '' : <div className={type !== 'aliyun-nvc' ? styles.captcha : styles.aliCaptcha} id={type !== 'aliyun-nvc' ? 'cbox' : 'captcha'} style={{ ...style2 }}></div>
      }
      {
        reset && <div id='id' className={styles.loading}></div>
      }
      {
        type === 'aliyun-image-restore' && <div id="AliyunCaptcha" style={{ display: 'none'}}></div>
      }
    </div>
  )
}

export default Verify
